import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {removePreset} from 'src/openapi/admin/apis/EntitlementsPresetApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    presetId: string,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemovePreset = ({presetId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((reason: string) => apiDispatch(
        removePreset({presetId, deletePresetRequest: {reason}}),
    ), [presetId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
